import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ResponseNotificationService} from "../../../core/services/response-notification.service";
import {AuthenticationRestService} from "../../../core/services";
import {TokenApiModel} from "../../../api/models/token.api.model";

@Component({
  selector: 'app-deny-invitation',
  templateUrl: './deny-invitation.component.html',
  styleUrls: ['./deny-invitation.component.scss']
})
export class DenyInvitationComponent implements OnInit {
  private token: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private as: AuthenticationRestService,
    private rns: ResponseNotificationService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.token = params.token;
      }
    );
    if (this.token && typeof this.token === 'string') {
      const token = new TokenApiModel();
      token.token = this.token;
      this.as.denyOwnerInvitation(token).subscribe(
        successResponse => {
          this.rns.emitMessage(successResponse.message);
        }
      )
        .add(() => {
          this.router.navigate(['/'])
        });
    }
  }
}
